module.exports = __webpack_public_path__ + "images/de2427a8b010fc931c45122cc0fcc4fc-instagram.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social/instagram.png
// module id = ./src/assets/images/social/instagram.png
// module chunks = 0